/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderSource,
  OrderSourceOptional,
  OrderSourceMetaI,
  OrderSourceTrackedI,
} from "./order-source";
import { OrderSourceTracked, OrderSourceMeta } from "./order-source";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderStateNew,
  OrderStateNewOptional,
  OrderStateNewMetaI,
  OrderStateNewTrackedI,
} from "./order-state-new";
import { OrderStateNewTracked, OrderStateNewMeta } from "./order-state-new";

/**
 *
 * @export
 * @interface OrderBase
 */
export interface OrderBaseOptional {
  /**
   *
   * @type {OrderSource}
   * @memberof OrderBase
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderBase
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderBase
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderBase
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderBase
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderBase
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderBase
   */
  version?: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderBase
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderBase
   */
  squareOrderId?: string;
}

export interface OrderBase extends OrderBaseOptional {
  /**
   *
   * @type {OrderSource}
   * @memberof OrderBase
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderBase
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderBase
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderBase
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderBase
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderBase
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderBase
   */
  version: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderBase
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderBase
   */
  squareOrderId?: string;
}

export interface OrderBaseTrackedI {
  /**
   *
   * @type {OrderSource}
   * @memberof OrderBase
   */
  orderSource?: OrderSource;
  orderSourceIsSet: boolean;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderBase
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderBase
   */
  amountDiscountsCents?: number;
  amountDiscountsCentsIsSet: boolean;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderBase
   */
  amountTaxesCents?: number;
  amountTaxesCentsIsSet: boolean;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderBase
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderBase
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderBase
   */
  version?: number;
  versionIsSet: boolean;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderBase
   */
  orderStatus?: OrderStateNew;
  orderStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderBase
   */
  squareOrderId?: string;
  squareOrderIdIsSet: boolean;
}

transformDatesMap.set("OrderBase", function (model: OrderBase) {});

export type OrderBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  orderSource: PropertyMeta<OrderSourceMetaI>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  version: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderStatus: PropertyMeta<OrderStateNewMetaI>;
  //isDate: false
  //isDatetime: false
  squareOrderId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var OrderBaseMeta: OrderBaseMetaI = {} as OrderBaseMetaI;
OrderBaseMeta = typeMeta("OrderBase", {
  orderSource: propertyMeta(
    "orderSource",
    false,
    false,
    false,
    OrderSourceMeta,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsCents: propertyMeta(
    "amountDiscountsCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesCents: propertyMeta(
    "amountTaxesCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  version: propertyMeta("version", false, true, false, MetaTypesBase.number),
  orderStatus: propertyMeta(
    "orderStatus",
    false,
    false,
    false,
    OrderStateNewMeta,
  ),
  squareOrderId: propertyMeta(
    "squareOrderId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = OrderBaseMeta;

registerMeta(() => {});

export class OrderBaseTracked implements OrderBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  orderSource__I?: OrderSource = undefined;
  orderSourceIsSet: boolean = false;
  set orderSource(v: undefined | OrderSource) {
    if (v !== undefined) {
      this.orderSource__I = v;
      this.orderSourceIsSet = true;
    } else {
      this.orderSource__I = v || undefined;
      this.orderSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderSource() {
    return this.orderSource__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountDiscountsCents__I?: number = undefined;
  amountDiscountsCentsIsSet: boolean = false;
  set amountDiscountsCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsCents__I = v;
      this.amountDiscountsCentsIsSet = true;
    } else {
      this.amountDiscountsCents__I = v || undefined;
      this.amountDiscountsCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsCents() {
    return this.amountDiscountsCents__I;
  }
  amountTaxesCents__I?: number = undefined;
  amountTaxesCentsIsSet: boolean = false;
  set amountTaxesCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesCents__I = v;
      this.amountTaxesCentsIsSet = true;
    } else {
      this.amountTaxesCents__I = v || undefined;
      this.amountTaxesCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesCents() {
    return this.amountTaxesCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  version__I?: number = undefined;
  versionIsSet: boolean = false;
  set version(v: undefined | number) {
    if (v !== undefined) {
      this.version__I = v;
      this.versionIsSet = true;
    } else {
      this.version__I = v || undefined;
      this.versionIsSet = true;
    }
    this.changeTracker = true;
  }
  get version() {
    return this.version__I;
  }
  orderStatus__I?: OrderStateNew = undefined;
  orderStatusIsSet: boolean = false;
  set orderStatus(v: undefined | OrderStateNew) {
    if (v !== undefined) {
      this.orderStatus__I = v;
      this.orderStatusIsSet = true;
    } else {
      this.orderStatus__I = v || undefined;
      this.orderStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderStatus() {
    return this.orderStatus__I;
  }
  squareOrderId__I?: string = undefined;
  squareOrderIdIsSet: boolean = false;
  set squareOrderId(v: undefined | string) {
    if (v !== undefined) {
      this.squareOrderId__I = v;
      this.squareOrderIdIsSet = true;
    } else {
      this.squareOrderId__I = v || undefined;
      this.squareOrderIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareOrderId() {
    return this.squareOrderId__I;
  }
  constructor(config?: OrderBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OrderBaseOptional,
    options?: AssignOptions,
  ): OrderBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.orderSource &&
      this.orderSourceApplyFilter(optionsRequired.filter)
    ) {
      this.orderSource = config.orderSource;
      if (optionsRequired.unassign) this.orderSourceIsSet = false;
      else this.orderSourceIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountDiscountsCents &&
      this.amountDiscountsCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsCents = config.amountDiscountsCents;
      if (optionsRequired.unassign) this.amountDiscountsCentsIsSet = false;
      else this.amountDiscountsCentsIsSet = true;
    }
    if (
      config.amountTaxesCents &&
      this.amountTaxesCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesCents = config.amountTaxesCents;
      if (optionsRequired.unassign) this.amountTaxesCentsIsSet = false;
      else this.amountTaxesCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (config.version && this.versionApplyFilter(optionsRequired.filter)) {
      this.version = config.version;
      if (optionsRequired.unassign) this.versionIsSet = false;
      else this.versionIsSet = true;
    }
    if (
      config.orderStatus &&
      this.orderStatusApplyFilter(optionsRequired.filter)
    ) {
      this.orderStatus = config.orderStatus;
      if (optionsRequired.unassign) this.orderStatusIsSet = false;
      else this.orderStatusIsSet = true;
    }
    if (
      config.squareOrderId &&
      this.squareOrderIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareOrderId = config.squareOrderId;
      if (optionsRequired.unassign) this.squareOrderIdIsSet = false;
      else this.squareOrderIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderBaseTrackedI {
    const cloned = {} as OrderBaseTrackedI;
    if (
      this.orderSourceIsSetDeep() &&
      this.orderSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderSourceIsSet = true;
      cloned.orderSource = this.orderSource;
    } else {
      //cloned.orderSourceIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountDiscountsCentsIsSetDeep() &&
      this.amountDiscountsCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsCentsIsSet = true;
      cloned.amountDiscountsCents = this.amountDiscountsCents;
    } else {
      //cloned.amountDiscountsCentsIsSet = false
    }
    if (
      this.amountTaxesCentsIsSetDeep() &&
      this.amountTaxesCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesCentsIsSet = true;
      cloned.amountTaxesCents = this.amountTaxesCents;
    } else {
      //cloned.amountTaxesCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.versionIsSetDeep() &&
      this.versionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.versionIsSet = true;
      cloned.version = this.version;
    } else {
      //cloned.versionIsSet = false
    }
    if (
      this.orderStatusIsSetDeep() &&
      this.orderStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderStatusIsSet = true;
      cloned.orderStatus = this.orderStatus;
    } else {
      //cloned.orderStatusIsSet = false
    }
    if (
      this.squareOrderIdIsSetDeep() &&
      this.squareOrderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareOrderIdIsSet = true;
      cloned.squareOrderId = this.squareOrderId;
    } else {
      //cloned.squareOrderIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderBaseTrackedI {
    if (!this.orderSourceApplyFilter(filter)) this.orderSourceIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountDiscountsCentsApplyFilter(filter))
      this.amountDiscountsCentsIsSet = false;

    if (!this.amountTaxesCentsApplyFilter(filter))
      this.amountTaxesCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.versionApplyFilter(filter)) this.versionIsSet = false;

    if (!this.orderStatusApplyFilter(filter)) this.orderStatusIsSet = false;

    if (!this.squareOrderIdApplyFilter(filter)) this.squareOrderIdIsSet = false;

    return this;
  }
  orderSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.orderSource,
      OrderBaseMeta,
      this.orderSource,
      this,
    );
  }
  orderSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderSourceIsSet && this.orderSourceApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.amountSubtotalCents,
      OrderBaseMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.amountDiscountsCents,
      OrderBaseMeta,
      this.amountDiscountsCents,
      this,
    );
  }
  amountDiscountsCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsCentsIsSet &&
      this.amountDiscountsCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.amountTaxesCents,
      OrderBaseMeta,
      this.amountTaxesCents,
      this,
    );
  }
  amountTaxesCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTaxesCentsIsSet && this.amountTaxesCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.amountTotalCents,
      OrderBaseMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.amountPaidCents,
      OrderBaseMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  versionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderBaseMeta.version, OrderBaseMeta, this.version, this);
  }
  versionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.versionIsSet && this.versionApplyFilter(filter)) return true;

    return false;
  }
  orderStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.orderStatus,
      OrderBaseMeta,
      this.orderStatus,
      this,
    );
  }
  orderStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderStatusIsSet && this.orderStatusApplyFilter(filter))
      return true;

    return false;
  }
  squareOrderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderBaseMeta.squareOrderId,
      OrderBaseMeta,
      this.squareOrderId,
      this,
    );
  }
  squareOrderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareOrderIdIsSet && this.squareOrderIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.orderSourceIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.versionIsSetDeep(filter)) return true;
    if (this.orderStatusIsSetDeep(filter)) return true;
    if (this.squareOrderIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
